import { useState } from "react";
import WhiteBox1 from "../../assets/images/white-box-1.png";
import RedBox2 from "../../assets/images/red-box-2.png";
import PurpleBox1 from "../../assets/images/purple-box-1.png";
import YellowBox2 from "../../assets/images/yellow-box-2.png";
import ProgramBg from "../../assets/images/faq-bg.png";

const Program = (props) => {
  const [program] = useState({
    day1: {
      date: [
        "10.00-10.10",
        "10.10-10.30",
        "10.30-11.00",
        "11.00-11.15",
        "11.15-11.45",
        "11.45-12.15",
        "12.15-12.45",
        "12.45-13.30",
        "13.30-13.45",
        "13.45-14.15",
        "14.15-15.00",
        "15.00-15.30",
        "15.30-16.00",
      ],
      eng: [
        "Opening Session",
        "Unilever 101",
        "Digital Marketing, Media & Commerce",
        "Coffee Break",
        "Data & Analytics",
        "D-Commerce",
        "Sales Technology & Digital Transformation",
        "Lunch Break",
        "Ice Breaking",
        "Digital Language Challenge",
        "2023 Digital Trends",
        "Panel with Unilever Talents",
        "Closing Ceremony",
      ],
      tr: [
        "Açılış Konuşması",
        "Unilever 101",
        "Dijital Pazarlama, Medya & Ticaret",
        "Ara",
        "Veri & Analitik",
        "D-Ticaret",
        "Satış Teknolojisi ve Dijital Dönüşüm",
        "Öğle Arası",
        "Online Aktivite",
        "Dijital Terminoloji Challenge",
        "2023 Dijital Trendler",
        "Unilever Yetenekleri Paneli",
        "Kapanış",
      ],
    },
    day2: { date: [], eng: [], tr: [] },
  });

  return (
    <section
      id="program"
      className="w-full bg-[#00D7C4] flex justify-center py-28 relative "
    >
      <div className="w-4/5 max-w-screen-xl flex flex-col items-center space-y-8 z-[1]">
        <div data-aos="fade-down">
          <h2 className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] text-[#7705BC] font-bold text-center">
            PROGRAM
          </h2>
        </div>
        <div className="w-full xl:w-4/5">
          <ul
            className="nav nav-tabs flex flex-row list-none border-b-0 pl-0 mb-4 w-full justify-between"
            id="tabs-tab"
            role="tablist"
          >
            <li
              data-aos="fade-right"
              className="nav-item w-[47%]"
              role="presentation"
            >
              <a
                href="#tabs-day1"
                className="nav-link block font-bold text-xl md:text-2xl text-center text-[#1F36C7] leading-tight uppercase border-x-0 border-0 px-6 py-3 my-2 bg-white hover:bg-white active
    "
                id="tabs-day1-tab"
                data-bs-toggle="pill"
                data-bs-target="#tabs-day1"
                role="tab"
                aria-controls="tabs-day1"
                aria-selected="true"
              >
                {props.currentLang === "eng" ? "Day 1" : "1. Gün"}
              </a>
            </li>
            <li
              data-aos="fade-left"
              className="nav-item w-[47%]"
              role="presentation"
            >
              <a
                href="#tabs-day2"
                className="nav-link block font-bold text-xl md:text-2xl text-center text-[#1F36C7] leading-tight uppercase border-x-0 border-0 px-6 py-3 my-2 bg-white hover:bg-white
    "
                id="tabs-day2-tab"
                data-bs-toggle="pill"
                data-bs-target="#tabs-day2"
                role="tab"
                aria-controls="tabs-day2"
                aria-selected="false"
              >
                {props.currentLang === "eng" ? "Day 2" : "2. Gün"}
              </a>
            </li>
          </ul>
          <div
            data-aos="fade-up"
            className="tab-content w-full"
            id="tabs-tabContent"
          >
            <div
              className="tab-pane fade show active w-full"
              id="tabs-day1"
              role="tabpanel"
              aria-labelledby="tabs-day1-tab"
            >
              <div className=" flex flex-row w-full">
                <ul className="w-1/3 px-4 md:px-5 text-right space-y-1">
                  {program.day1.date.map((item, index) => {
                    return (
                      <li
                        key={index}
                        className="text-[10px] sm:text-xl md:text-2xl text-[#1F36C7] font-bold"
                      >
                        {item}
                      </li>
                    );
                  })}
                </ul>
                <ul className="w-2/3 space-y-1">
                  {props.currentLang === "eng"
                    ? program.day1.eng.map((item, index) => {
                        return (
                          <li
                            key={index}
                            className="text-[10px] sm:text-xl md:text-2xl text-[#1F36C7] font-normal"
                          >
                            {item}
                          </li>
                        );
                      })
                    : program.day1.tr.map((item, index) => {
                        return (
                          <li
                            key={index}
                            className="text-xl md:text-2xl text-[#1F36C7] font-normal"
                          >
                            {item}
                          </li>
                        );
                      })}
                </ul>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="tabs-day2"
              role="tabpanel"
              aria-labelledby="tabs-day2-tab"
            >
              <div>
                <h3 className="font-bold text-xl md:text-2xl text-[#1F36C7] uppercase text-center">
                  {props.currentLang === "eng"
                    ? "TO BE ANNOUNCED!"
                    : "Yakında açıklanacaktır!"}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        className="w-14 md:w-28 absolute right-[5%] md:left-[5%] lg:left-[10%] xl:left-[15%] bottom-[15%] animate-[wiggle_10s_ease-in-out_infinite]"
        src={WhiteBox1}
        alt="white box"
      />
      <img
        className="w-14 absolute sm:left-[10%] sm:bottom-[30%] right-[12%] bottom-[5%] animate-[wiggle_10s_ease-in-out_infinite]"
        src={RedBox2}
        alt="red box"
      />
      <img
        className="absolute w-1/5 -top-12 sm:-top-20 md:-top-20 lg:-top-36 right-20"
        src={YellowBox2}
        alt="yellow box"
      />
      <img
        className="absolute w-14 md:w-24 top-1/5 right-10 animate-[spinselfrotate_10s_ease-in-out_infinite]"
        src={PurpleBox1}
        alt="purple box"
      />
      <img
        className="w-3/5 absolute top-0 left-0"
        src={ProgramBg}
        alt="program bg"
      />
    </section>
  );
};

export default Program;
